import { ActionTypes } from '../actions/types';

const initialState = {
  auftrag: undefined,
  defaultstatuskette: undefined,
  anzeigeStatus: undefined,
  message: undefined,
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload?: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.GET_TRACKTRACE: {
      return payload;
    }
    case ActionTypes.SET_NOTIFICATION: {
      console.log(payload);
      return { message: payload };
    }

    default:
      return state;
  }
}
